import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { api } from "@/lib/api";

// First next step for users who haven't talked to their coach yet: one tap sends a ready-made opener.
export const CoachStartCard = ({ opps }) => {
  const [show, setShow] = useState(false);
  const [chosen, setChosen] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/coach/started").then(r => setShow(!r.data.started)).catch(() => {});
    api.get("/progress").then(r => setChosen(r.data.progress?.chosen_path || null)).catch(() => {});
  }, []);

  const path = (opps || []).find(o => o.id === chosen) || (opps || [])[0];
  if (!show || !path) return null;
  const msg = `I picked ${path.title}. Walk me through Day 1 of my 7-day sprint.`;

  return (
    <div className="mt-5 card-panel-elevated p-5 border-[#FD0F10]/60" data-testid="coach-start-card">
      <div className="eyebrow text-[#FD0F10]">YOUR FIRST STEP</div>
      <p className="mt-1 text-base text-gray-100">Your coach is ready to walk you through Day 1 of <span className="text-white font-bold">{path.title}</span>.</p>
      <button onClick={async () => { await api.post("/path/start", { opportunity_id: path.id }).catch(() => {}); nav(`/coach?start=${encodeURIComponent(msg)}`); }} className="mt-4 w-full sm:w-auto hero-accent text-white font-display font-bold text-lg px-8 py-4 rounded-lg inline-flex items-center justify-center gap-2" data-testid="coach-start-btn">
        <MessageSquare size={18} /> Start with your coach
      </button>
    </div>
  );
};
